import React from "react";
import { Grid, Typography } from "@mui/material";

type YoutubeProps = {
  videos?: string[],
  title?: string,
}

export const Youtube = (props: YoutubeProps) => {
  if (!props.videos || props.videos.length === 0) return null;

  return (
    <React.Fragment>
      <Grid item paddingBottom={"20px"} />
      <Grid item xs={12} paddingBottom={"20px"}>
        {/* <hr /> */}
        <Grid container>
          <Grid item xs={12} style={{ paddingBottom: "10px"}}>
            <Typography component="h2" variant="h6">{props.title || "Videos"}</Typography>
          </Grid>
          {props.videos.map((url, index) => {
            return (
              <Grid item xs={12} lg={6} key={index} alignItems={"center"} justifyItems={"center"}>
                <iframe
                  width="100%"
                  height="315"
                  src={url}
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                ></iframe>
              </Grid>
            )
          })}
        </Grid>
      </Grid>
    </React.Fragment>
  )
}